import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

import { createKmdEasyImportFilesDetailViewRoutesMap } from './id'

export const createKmdEasyImportFilesRoutesMap = (prefix: string) => ({
  'fu51008/:id': (id = ':id') =>
    pathJoin(prefix)('fu51008')(id).chainMapAuto(
      createKmdEasyImportFilesDetailViewRoutesMap,
      {
        title: <T _str="KMD Easy import file rows" />,
        breadCrumbTitle: <T _str="KMD Easy import file rows" />,
      }
    ),
  'fu51007/:id': (id = ':id') =>
    pathJoin(prefix)('fu51007')(id).chainMapAuto(
      createKmdEasyImportFilesDetailViewRoutesMap,
      {
        title: <T _str="KMD Easy import file rows" />,
        breadCrumbTitle: <T _str="KMD Easy import file rows" />,
      }
    ),
})
